// src/components/InfoPageLayout.js

import React, { useEffect } from "react";
import AppFooter from "./AppFooter"; // Make sure this is imported correctly

const InfoPageLayout = ({ title, subtitle, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    // ✅ STEP 1: Make the main wrapper a vertical flex container.
    <div className="bg-background min-h-screen text-white selection:bg-primary-500/30 selection:text-white font-sans flex flex-col">
      {/* ✅ STEP 2: Create a <main> element with `flex-grow` to wrap ALL content except the footer. */}
      <main className="flex-grow">
        <div className="relative z-10 px-6 md:px-20 lg:px-32 xl:px-48">
          <header className="pt-24 md:pt-32 pb-16">
            <h1 className="text-5xl md:text-7xl font-black tracking-tighter mb-4 text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-500">
              {title}
            </h1>
            <p className="text-lg md:text-xl text-gray-400 max-w-3xl font-light">
              {subtitle}
            </p>
          </header>

          {/* This div holds the main page content passed in as children */}
          <div className="pb-24 border-t border-white/10 pt-16">{children}</div>
        </div>
      </main>

      <div className="px-6 md:px-20 lg:px-32 xl:px-48">
        <AppFooter />
      </div>
    </div>
  );
};

export default InfoPageLayout;
